import React from 'react';

const stylesByType = {
  success: {
    container: 'bg-emerald-50/90 border-emerald-200/80 text-emerald-900',
    icon: 'text-emerald-600',
    path: 'M5 13l4 4L19 7',
  },
  error: {
    container: 'bg-rose-50/90 border-rose-200/80 text-rose-900',
    icon: 'text-rose-600',
    path: 'M12 8v4m0 4h.01M4.93 19h14.14c1.54 0 2.5-1.67 1.73-3L13.73 4c-.77-1.33-2.69-1.33-3.46 0L3.2 16c-.77 1.33.19 3 1.73 3z',
  },
  info: {
    container: 'bg-sky-50/90 border-sky-200/80 text-sky-900',
    icon: 'text-sky-600',
    path: 'M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
  },
  warning: {
    container: 'bg-amber-50/90 border-amber-200/80 text-amber-950',
    icon: 'text-amber-600',
    path: 'M12 9v2m0 4h.01M10.29 3.86l-8 14A1 1 0 003.16 19h17.68a1 1 0 00.87-1.5l-8-14a1 1 0 00-1.74 0z',
  },
};

export function AlertMessage({
  message,
  type = 'info',
  onClose,
  className = '',
}) {
  if (!message) {
    return null;
  }

  const style = stylesByType[type] || stylesByType.info;

  return (
    <div
      role="status"
      className={`w-full border rounded-xl px-4 py-3 text-sm shadow-sm ${style.container} ${className}`}
    >
      <div className="flex items-start gap-3">
        <svg
          className={`w-5 h-5 mt-0.5 shrink-0 ${style.icon}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={style.path} />
        </svg>
        <p className="flex-1 leading-relaxed">{message}</p>
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            className="shrink-0 rounded-lg p-1 text-slate-500 hover:bg-black/5 hover:text-slate-800 transition-colors"
            aria-label="Dismiss message"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}
